import {
  COLOR_PALETTE,
  UnstyledButton as DsUnstyledButton,
  Group,
  Icon,
  OptimizeImage,
  Stack,
  Text,
  createPolymorphicComponent,
} from '@inflearn/ds-react-next';
import { faArrowRight } from '@inflearn/pro-regular-svg-icons';
import { forwardRef } from 'react';

export interface PartnersUnstyledButtonProps {
  imageSrc: string;
  label: string;
  description?: string;
}

export const PartnersUnstyledButton = createPolymorphicComponent<
  'button',
  PartnersUnstyledButtonProps
>(
  forwardRef<HTMLButtonElement, PartnersUnstyledButtonProps>(
    ({ imageSrc, label, description, ...props }, ref) => (
      <DsUnstyledButton
        ref={ref}
        py={20}
        pl={20}
        pr={24}
        bg="white"
        styles={{
          root: {
            borderRadius: 16,
            border: `1px solid ${COLOR_PALETTE.gray[3]}`,
            transition: 'background-color 0.2s ease',

            '@media (hover: hover)': {
              '&:hover': {
                backgroundColor: COLOR_PALETTE.gray[0],
                cursor: 'pointer',
              },
            },
          },
        }}
        {...props}
      >
        <Group gap={16} align="center" wrap="nowrap">
          <OptimizeImage src={imageSrc} w={40 * 2} width={40} height={40} alt={`${label} 아이콘`} />
          <Stack gap={4} align="flex-start">
            <Text size="md" fw={600}>
              {label}
            </Text>
            {description && <Text size="sm">{description}</Text>}
          </Stack>
          <Icon icon={faArrowRight} color="gray.7" size="md" css={{ marginLeft: 'auto' }} />
        </Group>
      </DsUnstyledButton>
    ),
  ),
);
